import React from 'react';
import { Grid, Typography, Box, Paper } from '@mui/material';
import HeaderBar from '@/common/layouts/HeaderBar';
import DefaultLayout from '@/common/layouts/DefaultLayout';
import Division from '@/common/components/Division';
import { getServerSidePropsPrefetch } from '@/common/utils/ssr';
import { ssrMenuItems } from '@/common/hooks/useMenuItems';
import HeroBanner from '@/common/components/HeroBanner';
import Footer from '@/common/layouts/Footer';
import { useGlobalContext } from '@/common/contexts/GlobalContext';
import sanitizeHtml from 'sanitize-html';


export default function Page() {
  const { siteName } = useGlobalContext()
  const { siteURL } = useGlobalContext()
  const { cookiePolicy } = useGlobalContext()
  const { contactEmail } = useGlobalContext()
  const cleanHtml = sanitizeHtml(cookiePolicy, {
    allowedTags: ['b', 'i', 'em', 'strong', 'a', 'br', 'ul', 'li', 'p'],
    allowedAttributes: {
      'a': ['href']
    }
  });
  return (
    <>
      <HeaderBar />
      <DefaultLayout>
        <Grid container direction="column">
          <HeroBanner />

          <Box display="flex" alignItems="center" marginBottom={2}>
            <Typography variant="h6">Cookies Policy</Typography>
          </Box>

          <Paper>
            <Box
              display="flex"
              flexDirection="row"
              flexWrap="wrap"
              justifyContent="space-evenly"
              padding={1}
            >
              <Box display="flex" alignItems="center" marginBottom={2}>
                {/* <Typography color="primary" variant="body1">{aboutUs}</Typography> */}
                <div
                  // add HTML sanitizing
                  dangerouslySetInnerHTML={{ __html: cleanHtml }}
                />
              </Box>
            </Box>
          </Paper>


          <Division />
        </Grid>
      </DefaultLayout>
      <Footer />
    </>
  );
}

export const getServerSideProps = getServerSidePropsPrefetch([
  ssrMenuItems,
]);
